
function Banner() {

    return (
        <section
            className="w-full text-white text-center h-[420px] lg:h-[360px] bg-cover bg-center mt-[210px] lg:mt-[75px] flex flex-col items-center"
            style={{
                backgroundImage:
                    "linear-gradient(rgba(44,62,80,0.8), rgba(44,62,80,0.9)), url('/images/banner.jpg')",
            }}
        >
            <h1 className="mt-[80px] font-bold text-[36px] lg:text-[38px]">TRUNG TÂM TRI THỨC SỐ</h1>
            <p className="px-[20px] mt-[20px] mb-[30px] lg:text-[20px]">Hệ thống học tập trực tuyến với bài giảng video, tài liệu tải về và đánh giá chi tiết</p>
            {/* <Button label="Bắt đầu học ngay" styleButton="w-[186px] h-[45px]" onClick={() => handleClick()} /> */}
        </section>
    );
}

export default Banner;
